import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../components/common/Button/Button";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import FooterContact from "../../../components/Footer/FooterContact";
import { useGetWithdrawDetailsQuery } from "../../../services/apiSlice";

const EarningWithdraw = ({ coin }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { withdrawId } = location.state || {};

  const { data: withdrawDetails, isLoading } = useGetWithdrawDetailsQuery({
    withdraw_id: withdrawId,
  });

  const handleBackToProfile = () => {
    navigate("/profile");
  };

  const handleWithdrawalHistory = () => {
    navigate("/profile/history");
  };

  return (
    <>
      <LoadingCommon isLoading={isLoading} />
      <div className="flex flex-col w-full h-screen bg-[#E1D2F3] overflow-y-auto scrollbar-hide">
        <div className="flex flex-col items-center justify-center bg-white rounded-md my-[72px] p-[30px] h-full mx-[30px] ">
          <div className="flex flex-col items-center justify-center gap-2">
            {/* <img
                src={images.Earning}
                alt="Earning Icon"
                className="w-[121px] h-[201.33px] mb-6"
              /> */}
            <h3 className="text-[#253FF6] text-[14px] xs:text-[16px] font-bold text-center mb-[30px] xs:mb-[50px]">
              {t("withDraw.withdrawalProcessed")}
            </h3>
            <div className="w-[150px] xs:w-[180px]">
              <Lottie
                loop={false}
                animationData={require("../../../images/animation/withdraw.json")}
              />
            </div>
            <h1 className="text-[#253FF6] text-[22px] xs:text-[24px] font-bold mb-2 text-center">
              {t("withDraw.youEarned")} $
              {withdrawDetails?.data?.transaction_fee > 0
                ? withdrawDetails?.data?.receive_amount.toFixed(2)
                : (withdrawDetails?.data?.receive_amount - 0.5).toFixed(2)}
              !
            </h1>
            <p className="text-[#333333] text-[16px] xs:text-[18px] font-[400] text-center">
              {t("withDraw.allow3WorkingDayForWithdraw")}
            </p>
            <div className="flex flex-col items-center w-full max-w-[376px]">
              <Button
                text={t("withDraw.backToProfile")}
                onClick={handleBackToProfile}
                className="bg-[#253FF6] text-white font-medium text-[16px] xs:text-lg rounded-md h-[50px] !mt-0 w-full"
              />

              <button
                onClick={handleWithdrawalHistory}
                className="text-[#A0A0A0] text-[14px] xs:text-base font-medium underline mt-5"
              >
                {t("historyWithdraw.withdrawHistory")}
              </button>
            </div>
          </div>
        </div>
        <FooterContact className="!bg-[#E1D2F3]"/>
      </div>
    </>
  );
};

export default EarningWithdraw;
